import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import STYLE_CONSTANTS from '~/style/constants'

const ItemContainer = styled.div`
  max-width: ${props => props.maxWidth};
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: ${props => props.margin ? props.margin : '0.5rem 0rem'};
  font-family: ${props => props.theme.fonts.avenirNextMedium};
`

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  margin-bottom: 6px;
`

const Title = styled.div`
  font-size: 1rem;
  color: ${STYLE_CONSTANTS.colors.ui.headerGray};
  margin-bottom: 1rem;
`

const Text = styled.div`
  font-size: 0.875rem;
  color: ${props => props.theme.colors.text.label};
  text-align: center;
`

const Item = ({ title, imgSrc, text, maxWidth, margin }) => {
  return (
    <ItemContainer maxWidth={maxWidth} margin={margin}>
      <IconContainer>
        <img src={imgSrc} alt={title} />
      </IconContainer>
      <Title>{title}</Title>
      <Text>{text}</Text>
    </ItemContainer>
  )
}

Item.defaultProps = {
  title: null,
  imgSrc: null,
  text: null,
  maxWidth: '300px'
}

Item.propTypes = {
  title: PropTypes.string,
  imgSrc: PropTypes.string,
  text: PropTypes.string,
  maxWidth: PropTypes.string
}

export default Item
